// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';
import BaseModule from '../_base_module';

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,
};

// getters
const getters = {
  ...BaseModule.getters,
  // dummy_getter(state, getters, rootState, rootGetters) {
  //
  // }
};

// actions
const actions = {
  ...BaseModule.actions,
  store({state, commit, dispatch, getters, rootState}, payload) {
    return dispatch('api/postEndpoint', {
      endpoint: '/feedback',
      data: payload,
    }, {root: true}).then(response => {
      commit('add_to_data', {data: response.data.data});
    });
  }
};

// mutations
const mutations = {
  ...BaseModule.mutations,
  // dummy_mutation (state, id) {
  //     state.id = id;
  // },
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
